import { cn } from "../../lib/utils";
import { Logo } from "./Logo";

interface BrandedSpinnerProps {
    size?: "sm" | "md" | "lg";
    animation?: "rotate" | "pulse" | "bounce" | "hybrid";
    className?: string;
    speed?: "slow" | "normal" | "fast";
}

export function BrandedSpinner({
    size = "md",
    animation = "rotate",
    className,
    speed = "normal",
}: BrandedSpinnerProps) {
    const sizeClasses = {
        sm: "h-6 w-6",
        md: "h-8 w-8",
        lg: "h-12 w-12",
    };

    const logoSizeMap = {
        sm: "sm" as const,
        md: "md" as const,
        lg: "lg" as const,
    };

    const getAnimationClass = () => {
        const speedModifier = {
            slow: "duration-[2s]",
            normal: "duration-[1.5s]",
            fast: "duration-[1s]",
        };

        switch (animation) {
            case "rotate":
                return `animate-spin ${speedModifier[speed]}`;
            case "pulse":
                return `animate-pulse ${speedModifier[speed]}`;
            case "bounce":
                return "animate-bounce";
            case "hybrid":
                return `animate-spin ${speedModifier[speed]} hover:animate-pulse`;
            default:
                return `animate-spin ${speedModifier[speed]}`;
        }
    };

    return (
        <div
            className={cn("flex items-center justify-center", sizeClasses[size], className)}
            role="status"
            aria-label="Loading"
        >
            <div
                className={cn(getAnimationClass(), "transition-opacity duration-300 ease-in-out")}
                style={{
                    filter: animation === "hybrid" ? "drop-shadow(0 0 4px rgba(59, 130, 246, 0.3))" : undefined,
                }}
            >
                <Logo
                    size={logoSizeMap[size]}
                    className={cn("opacity-80 transition-opacity", animation === "pulse" && "hover:opacity-100")}
                />
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    );
}
